module.exports = __webpack_public_path__ + "img/logo.829a2fd7.png";